import React, { useState } from "react";
import Innerbanner from "../../components/inner-banner";
import SelectDropdown from "../../components/form-fields/select";
import Image from "../../components/ui/image";
import { Images } from "../../lib/images";
import MultiSelect from "../../components/form-fields/multipleSelect";
import Linechart from "../../components/line-chart/linechart";

const fruitOptions = [
  { value: "Arsenal Fc", label: "Arsenal Fc" },
  { value: "Aston Villa Fc", label: "Aston Villa Fc" },
];


const Analytics: React.FC = () => {
  const headingText = "Analytics";


  return (
    <div className="w-full">
      <Innerbanner bnrHeading={headingText} />

      <section className="bg-background p-5">
        <div className="container mx-auto pb-20">
          {/* <div className="w-full flex gap-3 border-b border-gray-300 pb-5 mb-3 flex-wrap justify-between">
            <MultiSelect options={fruitOptions} placeholder="Select..." />
            <div className="flex gap-6 font-normal text-sm">
              <div className="flex items-center gap-2"><span className="inline-block w-5 h-5 rounded-md border-gray-700 bg-[#EF0107]"></span> Arsenal Fc</div>
              <div className="flex items-center gap-2"><span className="inline-block w-5 h-5 rounded-md border-gray-700 bg-[#95BFE5]"></span> Aston Villa Fc</div>
            </div>
          </div> */}
          <div>
            <Linechart />
          </div>      

         
        </div>
      </section>
    </div>
  )
}

export default Analytics